export const TooltipConfig = {
    enabled: true,
    intersect: false,
    mode: 'index',
    titleFontSize: 16,
    bodyFontSize: 15,
    xPadding: 12,
    yPadding: 12
};
